export const UspsExemptionCodes = [
  {
    key: 'NOEEI 30.36',
    value: 'NOEEI 30.36',
  },
  {
    key: 'NOEEI 30.37(a)',
    value: 'NOEEI 30.37(a)',
  },
  {
    key: 'NOEEI 30.37(b)',
    value: 'NOEEI 30.37(b)',
  },
  {
    key: 'NOEEI 30.37(c)',
    value: 'NOEEI 30.37(c)',
  },
  {
    key: 'NOEEI 30.37(d)',
    value: 'NOEEI 30.37(d)',
  },
  {
    key: 'NOEEI 30.37(f)',
    value: 'NOEEI 30.37(f)',
  },
  {
    key: 'NOEEI 30.37(g)',
    value: 'NOEEI 30.37(g)',
  },
  {
    key: 'NOEEI 30.37(h)',
    value: 'NOEEI 30.37(h)',
  },
  {
    key: 'NOEEI 30.37(i)',
    value: 'NOEEI 30.37(i)',
  },
  {
    key: 'NOEEI 30.37(j)',
    value: 'NOEEI 30.37(j)',
  },
  {
    key: 'NOEEI 30.37(k)',
    value: 'NOEEI 30.37(k)',
  },
  {
    key: 'NOEEI 30.37(l)',
    value: 'NOEEI 30.37(l)',
  },
  {
    key: 'NOEEI 30.37(m)',
    value: 'NOEEI 30.37(m)',
  },
  {
    key: 'NOEEI 30.37(n)',
    value: 'NOEEI 30.37(n)',
  },
  {
    key: 'NOEEI 30.37(o)',
    value: 'NOEEI 30.37(o)',
  },
  {
    key: 'NOEEI 30.37(p)',
    value: 'NOEEI 30.37(p)',
  },
  {
    key: 'NOEEI 30.37(s)',
    value: 'NOEEI 30.37(s)',
  },
  {
    key: 'NOEEI 30.37(t)',
    value: 'NOEEI 30.37(t)',
  },
  {
    key: 'NOEEI 30.37(u)',
    value: 'NOEEI 30.37(u)',
  },
  {
    key: 'NOEEI 30.37(v)',
    value: 'NOEEI 30.37(v)',
  },
  {
    key: 'NOEEI 30.37(w)',
    value: 'NOEEI 30.37(w)',
  },
  {
    key: 'NOEEI 30.37(x)',
    value: 'NOEEI 30.37(x)',
  },
  {
    key: 'NOEEI 30.37(y)',
    value: 'NOEEI 30.37(y)',
  },
];
